'use client';
import { createContext } from 'react';

import type { PlaylistItem } from '@repo/ui/src/types/youtubeLink';

const PlaylistContext = createContext<Array<PlaylistItem> | undefined>(undefined);

export default PlaylistContext;
